<template>
  <div id="printable" class="register-container">
    <!-- Header -->
    <div class="header">
      <div class="facility-name">
        TUURU COTTOLENGO HEALTH CENTRE - AR2026259
      </div>
      <div class="facility-details">
        <div>Igembe Central</div>
        <div>P.O BOX 77 - Meru | Tel: 254254746758069</div>
        <div>Email: suore.tuuru@cottolengo.org</div>
      </div>
      <div class="register-title">
        MOH 333 - MATERNITY REGISTER (Labour and Delivery)
      </div>
    </div>

    <!-- Date Range and Generated By Bar -->
    <div class="info-bar">
      <div class="info-left">
        <div class="date-range">
          <div class="info-item">
            <span class="info-label">From:</span>
            <input
              type="date"
              v-model="dateFrom"
              class="date-input"
              @change="filterRecords"
            />
          </div>
          <div class="info-item">
            <span class="info-label">To:</span>
            <input
              type="date"
              v-model="dateTo"
              class="date-input"
              @change="filterRecords"
            />
          </div>
          <button @click="clearDates" class="btn-clear">Clear</button>
        </div>
        <div class="info-item">
          <span class="info-label">Generated By:</span>
          <span class="info-value">{{ generatedBy }}</span>
        </div>
      </div>
      <button @click="printPage" class="btn-print">Print Register</button>
    </div>

    <!-- Date Range Display for Print -->
    <div class="print-date-range">
      <strong>Report Period:</strong> {{ formattedDateFrom }} to
      {{ formattedDateTo }}
    </div>

    <!-- Summary Statistics -->
    <div class="summary-stats">
      <div class="stat-box">
        <span class="stat-label">Total Deliveries</span>
        <span class="stat-number">{{ totalDeliveries }}</span>
      </div>
      <div class="stat-box">
        <span class="stat-label">Live Births</span>
        <span class="stat-number">{{ liveBirths }}</span>
      </div>
      <div class="stat-box">
        <span class="stat-label">C-Sections</span>
        <span class="stat-number">{{ cSections }}</span>
      </div>
      <div class="stat-box">
        <span class="stat-label">Maternal Deaths</span>
        <span class="stat-number">{{ maternalDeaths }}</span>
      </div>
    </div>

    <!-- Table -->
    <div class="table-wrapper">
      <table class="maternity-table">
        <thead>
          <tr>
            <th rowspan="2">#</th>
            <th rowspan="2">Date of Admission</th>
            <th rowspan="2">Maternity No</th>
            <th rowspan="2">Full Names</th>
            <th rowspan="2">Age</th>
            <th rowspan="2">Gravida</th>
            <th rowspan="2">Para</th>
            <th rowspan="2">Gestation (weeks)</th>
            <th rowspan="2">Date of Delivery</th>
            <th rowspan="2">Time of Delivery</th>
            <th colspan="2">Mode of Delivery</th>
            <th colspan="2">Baby Outcome</th>
            <th rowspan="2">Baby Sex</th>
            <th rowspan="2">Birth Weight (kg)</th>
            <th rowspan="2">Maternal Outcome</th>
            <th rowspan="2">Complications</th>
            <th rowspan="2">Attendant</th>
            <th rowspan="2">Remarks</th>
          </tr>
          <tr class="sub-header">
            <th>SVD</th>
            <th>C/Section</th>
            <th>Alive</th>
            <th>Stillborn</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(record, index) in filteredRecords" :key="index">
            <td>{{ index + 1 }}</td>
            <td>{{ record.admissionDate }}</td>
            <td>{{ record.maternityNo }}</td>
            <td>{{ record.fullNames }}</td>
            <td>{{ record.age }}</td>
            <td>{{ record.gravida }}</td>
            <td>{{ record.para }}</td>
            <td>{{ record.gestation }}</td>
            <td>{{ record.deliveryDate }}</td>
            <td>{{ record.deliveryTime }}</td>
            <td class="text-center">
              <span v-if="record.svd" class="yes-badge">Yes</span>
              <span v-else class="no-badge">No</span>
            </td>
            <td class="text-center">
              <span v-if="record.cSection" class="yes-badge">Yes</span>
              <span v-else class="no-badge">No</span>
            </td>
            <td class="text-center">
              <span v-if="record.babyAlive" class="yes-badge">Alive</span>
              <span v-else class="no-badge">--</span>
            </td>
            <td class="text-center">
              <span v-if="record.stillborn" class="positive">Stillborn</span>
              <span v-else class="na-badge">--</span>
            </td>
            <td class="text-center">{{ record.babySex }}</td>
            <td>{{ record.birthWeight }}</td>
            <td class="text-center">
              <span v-if="record.maternalOutcome === 'Alive'" class="yes-badge"
                >Alive</span
              >
              <span
                v-else-if="record.maternalOutcome === 'Dead'"
                class="positive"
                >Dead</span
              >
              <span v-else class="na-badge">--</span>
            </td>
            <td>{{ record.complications }}</td>
            <td>{{ record.attendant }}</td>
            <td>{{ record.remarks }}</td>
          </tr>
          <tr v-if="filteredRecords.length === 0">
            <td colspan="21" class="empty-row">
              No maternity records found for the selected date range
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: "MOH333Maternity",
  data() {
    return {
      dateFrom: "2026-04-01",
      dateTo: "2026-04-30",
      generatedBy: "SR. JANE KAREGI MUNYUGI",
      maternityRecords: [
        {
          admissionDate: "2026-04-22",
          maternityNo: "MAT001",
          fullNames: "Mary Wanjiku",
          age: 28,
          gravida: 2,
          para: 1,
          gestation: 39,
          deliveryDate: "2026-04-22",
          deliveryTime: "08:30",
          svd: true,
          cSection: false,
          babyAlive: true,
          stillborn: false,
          babySex: "M",
          birthWeight: 3.2,
          maternalOutcome: "Alive",
          complications: "None",
          attendant: "Midwife J. Karani",
          remarks: "Normal delivery",
        },
        {
          admissionDate: "2026-04-22",
          maternityNo: "MAT002",
          fullNames: "Grace Muthoni",
          age: 32,
          gravida: 3,
          para: 2,
          gestation: 38,
          deliveryDate: "2026-04-22",
          deliveryTime: "14:45",
          svd: true,
          cSection: false,
          babyAlive: true,
          stillborn: false,
          babySex: "F",
          birthWeight: 3.0,
          maternalOutcome: "Alive",
          complications: "None",
          attendant: "Midwife P. Muthoni",
          remarks: "Breastfeeding well",
        },
        {
          admissionDate: "2026-04-21",
          maternityNo: "MAT003",
          fullNames: "Jane Karimi",
          age: 35,
          gravida: 4,
          para: 3,
          gestation: 37,
          deliveryDate: "2026-04-21",
          deliveryTime: "22:15",
          svd: false,
          cSection: true,
          babyAlive: true,
          stillborn: false,
          babySex: "M",
          birthWeight: 2.8,
          maternalOutcome: "Alive",
          complications: "Fetal distress",
          attendant: "Dr. S. Mwangi",
          remarks: "Emergency C-section",
        },
        {
          admissionDate: "2026-04-20",
          maternityNo: "MAT004",
          fullNames: "Sarah Mwikali",
          age: 24,
          gravida: 1,
          para: 0,
          gestation: 40,
          deliveryDate: "2026-04-20",
          deliveryTime: "11:00",
          svd: true,
          cSection: false,
          babyAlive: true,
          stillborn: false,
          babySex: "F",
          birthWeight: 3.4,
          maternalOutcome: "Alive",
          complications: "Prolonged labour",
          attendant: "Midwife J. Karani",
          remarks: "Episiotomy done",
        },
        {
          admissionDate: "2026-04-19",
          maternityNo: "MAT005",
          fullNames: "Lucy Mwende",
          age: 29,
          gravida: 2,
          para: 1,
          gestation: 35,
          deliveryDate: "2026-04-19",
          deliveryTime: "05:30",
          svd: true,
          cSection: false,
          babyAlive: true,
          stillborn: false,
          babySex: "M",
          birthWeight: 2.5,
          maternalOutcome: "Alive",
          complications: "Preterm labour",
          attendant: "Midwife P. Muthoni",
          remarks: "Baby in NBU",
        },
        {
          admissionDate: "2026-04-18",
          maternityNo: "MAT006",
          fullNames: "Esther Kendi",
          age: 41,
          gravida: 5,
          para: 4,
          gestation: 39,
          deliveryDate: "2026-04-18",
          deliveryTime: "16:20",
          svd: false,
          cSection: true,
          babyAlive: true,
          stillborn: false,
          babySex: "F",
          birthWeight: 3.1,
          maternalOutcome: "Alive",
          complications: "Elderly multigravida",
          attendant: "Dr. S. Mwangi",
          remarks: "Elective C-section",
        },
        {
          admissionDate: "2026-04-17",
          maternityNo: "MAT007",
          fullNames: "Ruth Nkirote",
          age: 26,
          gravida: 1,
          para: 0,
          gestation: 41,
          deliveryDate: "2026-04-17",
          deliveryTime: "19:00",
          svd: true,
          cSection: false,
          babyAlive: false,
          stillborn: true,
          babySex: "M",
          birthWeight: 3.6,
          maternalOutcome: "Alive",
          complications: "Post-term, fresh stillbirth",
          attendant: "Midwife J. Karani",
          remarks: "Counselled",
        },
        {
          admissionDate: "2026-04-16",
          maternityNo: "MAT008",
          fullNames: "Naomi Gacheri",
          age: 33,
          gravida: 3,
          para: 2,
          gestation: 38,
          deliveryDate: "2026-04-16",
          deliveryTime: "09:45",
          svd: true,
          cSection: false,
          babyAlive: true,
          stillborn: false,
          babySex: "M",
          birthWeight: 3.3,
          maternalOutcome: "Alive",
          complications: "None",
          attendant: "Midwife P. Muthoni",
          remarks: "Normal delivery",
        },
      ],
    };
  },
  computed: {
    formattedDateFrom() {
      return this.dateFrom
        ? new Date(this.dateFrom).toLocaleDateString("en-GB")
        : "Start";
    },
    formattedDateTo() {
      return this.dateTo
        ? new Date(this.dateTo).toLocaleDateString("en-GB")
        : "End";
    },
    filteredRecords() {
      let filtered = this.maternityRecords;
      if (this.dateFrom) {
        filtered = filtered.filter((r) => r.admissionDate >= this.dateFrom);
      }
      if (this.dateTo) {
        filtered = filtered.filter((r) => r.admissionDate <= this.dateTo);
      }
      return filtered;
    },
    totalDeliveries() {
      return this.filteredRecords.length;
    },
    liveBirths() {
      return this.filteredRecords.filter((r) => r.babyAlive).length;
    },
    cSections() {
      return this.filteredRecords.filter((r) => r.cSection).length;
    },
    maternalDeaths() {
      return this.filteredRecords.filter((r) => r.maternalOutcome === "Dead")
        .length;
    },
  },
  methods: {
    clearDates() {
      this.dateFrom = "";
      this.dateTo = "";
    },
    filterRecords() {
      // Computed property handles filtering
    },
    printPage() {
      window.print();
    },
  },
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.register-container {
  background: white;
  min-height: 100vh;
  padding: 20px;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
}

.header {
  text-align: center;
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 2px solid #1a56db;
}

.facility-name {
  font-size: 20px;
  font-weight: bold;
  color: #1a56db;
  margin-bottom: 6px;
}

.facility-details {
  font-size: 11px;
  color: #4b5563;
  line-height: 1.4;
  margin-bottom: 10px;
}

.register-title {
  font-size: 14px;
  font-weight: bold;
  background: #f3f4f6;
  display: inline-block;
  padding: 5px 16px;
  border-radius: 20px;
  color: #1f2937;
}

.info-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 16px;
  padding: 12px 16px;
  background: #f9fafb;
  border-radius: 10px;
  border: 1px solid #e5e7eb;
}

.info-left {
  display: flex;
  gap: 24px;
  flex-wrap: wrap;
  align-items: center;
}

.date-range {
  display: flex;
  gap: 12px;
  align-items: center;
  flex-wrap: wrap;
}

.info-item {
  display: flex;
  align-items: center;
  gap: 6px;
}

.info-label {
  font-size: 12px;
  font-weight: 600;
  color: #374151;
}

.info-value {
  font-size: 12px;
  color: #1f2937;
  font-weight: 500;
}

.date-input {
  padding: 5px 8px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 12px;
}

.btn-clear {
  padding: 5px 12px;
  background: #6b7280;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 11px;
  font-weight: 500;
}

.btn-clear:hover {
  background: #4b5563;
}

.btn-print {
  padding: 8px 20px;
  background: #3b82f6;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
}

.btn-print:hover {
  background: #2563eb;
}

.print-date-range {
  text-align: center;
  padding: 8px;
  margin-bottom: 16px;
  background: #fef3c7;
  border-left: 4px solid #f59e0b;
  font-size: 12px;
  color: #92400e;
  border-radius: 6px;
}

.summary-stats {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
  justify-content: center;
  flex-wrap: wrap;
}

.stat-box {
  background: linear-gradient(135deg, #1e3a5f 0%, #2563eb 100%);
  border-radius: 12px;
  padding: 12px 20px;
  text-align: center;
  min-width: 150px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.stat-label {
  display: block;
  font-size: 11px;
  font-weight: 600;
  color: #bfdbfe;
  margin-bottom: 6px;
  text-transform: uppercase;
}

.stat-number {
  display: block;
  font-size: 26px;
  font-weight: bold;
  color: white;
}

.table-wrapper {
  overflow-x: auto;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  max-height: 65vh;
  overflow-y: auto;
}

.maternity-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 11px;
  min-width: 1600px;
}

.maternity-table th {
  background: #1f2937;
  color: white;
  padding: 8px 4px;
  font-weight: 600;
  text-align: center;
  border: 1px solid #374151;
  position: sticky;
  top: 0;
  z-index: 10;
}

.maternity-table th.sub-header {
  background: #374151;
  font-size: 10px;
}

.maternity-table td {
  border: 1px solid #d1d5db;
  padding: 6px 4px;
  text-align: left;
}

.maternity-table td.text-center {
  text-align: center;
}

.yes-badge {
  background: #d1fae5;
  color: #065f46;
  padding: 2px 6px;
  border-radius: 10px;
  font-size: 10px;
  font-weight: 600;
  display: inline-block;
}

.no-badge {
  background: #fee2e2;
  color: #991b1b;
  padding: 2px 6px;
  border-radius: 10px;
  font-size: 10px;
  font-weight: 600;
  display: inline-block;
}

.positive {
  background: #fee2e2;
  color: #dc2626;
  padding: 2px 6px;
  border-radius: 10px;
  font-size: 10px;
  font-weight: 600;
  display: inline-block;
}

.na-badge {
  color: #9ca3af;
  font-weight: 500;
}

.empty-row {
  text-align: center;
  padding: 30px;
  color: #6b7280;
}

@media print {
  @page {
    size: landscape;
    margin: 0.3cm;
  }

  .btn-print,
  .btn-clear,
  .date-input {
    display: none;
  }

  .info-bar {
    display: none;
  }

  .print-date-range {
    background: #fef3c7;
    margin: 10px 0;
    padding: 5px;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }

  .summary-stats {
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }

  .register-container {
    padding: 0.2cm;
  }

  .header {
    margin-bottom: 5px;
  }

  .facility-name {
    font-size: 14px;
  }

  .facility-details {
    font-size: 8px;
  }

  .register-title {
    font-size: 10px;
  }

  .table-wrapper {
    overflow: visible !important;
    max-height: none;
  }

  .maternity-table {
    font-size: 8px;
    min-width: 0 !important;
  }

  .maternity-table th {
    padding: 3px 2px;
    font-size: 8px;
    background: #e5e7eb !important;
    color: black !important;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }

  .maternity-table td {
    padding: 3px 2px;
    font-size: 7.5px;
  }
}
</style>
